function capitalizeFirstLetter(string) {
  string = string.replace(/_/g, " ");
  return string.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
    letter.toUpperCase()
  );
}

function getSize(pantSize, inseam) {
  console.log("pants", pantSize, "inseam", inseam);
  let isSizeAvailable = false;
  for (let index = 0; index < pantSizeChart.length; index++) {
    const size = pantSizeChart[index];
    if (
      parseFloat(size.pant_size) == parseFloat(pantSize) &&
      parseFloat(size.inseam) == parseFloat(inseam)
    ) {
      console.log("inseam", inseam);
      let sizeHTML = "";
      for (const key in size) {
        if (Object.hasOwnProperty.call(size, key)) {
          const element = size[key];
          sizeHTML =
            sizeHTML +
            `<li><span>${capitalizeFirstLetter(
              key
            )}</span><span class="push">${element}"</span></li>`;
        }
      }
      isSizeAvailable = true;
      console.log(sizeHTML);
      $("#selected-size-details").html(sizeHTML);
    }
  }
  return isSizeAvailable;
}
function getSizeSuit(pantSize, inseam, selectedPantType) {

  let isSizeAvailable = false;
  if (selectedPantType) {
    console.log('trueeeggt',selectedPantType)
    for (let index = 0; index < dessPantSizeChart.length; index++) {
      const size = dessPantSizeChart[index];
      if (
        parseFloat(size.pant_size) == parseFloat(pantSize) &&
        parseFloat(size.inseam) == parseFloat(inseam)
      ) {
        console.log("inseam", inseam);
        let sizeHTML = "";
        for (const key in size) {
          if (Object.hasOwnProperty.call(size, key)) {
            const element = size[key];
            sizeHTML =
              sizeHTML +
              `<li><span>${capitalizeFirstLetter(
                key
              )}</span><span class="push">${element}"</span></li>`;
          }
        }
        isSizeAvailable = true;
        $("#selected-size-details_suit").html(sizeHTML);
      }
    }
  } else {
    for (let index = 0; index < highWaistedPantSizeChart.length; index++) {
      const size = highWaistedPantSizeChart[index];
      if (
        parseFloat(size.pant_size) == parseFloat(pantSize) &&
        parseFloat(size.inseam) == parseFloat(inseam)
      ) {
        let sizeHTML = "";
        for (const key in size) {
          if (Object.hasOwnProperty.call(size, key)) {
            const element = size[key];
            sizeHTML =
              sizeHTML +
              `<li><span>${capitalizeFirstLetter(
                key
              )}</span><span class="push">${element}"</span></li>`;
          }
        }
        isSizeAvailable = true;
        $("#selected-size-details_suit").html(sizeHTML);
      }
    }
  }
  return isSizeAvailable;
}

function getShirtSize(fit, shirtSize) {
  let isSizeAvailable = false;
  for (let index = 0; index < pantSizeChart.length; index++) {
    const size = pantSizeChart[index];
    if (
      size.fit_type.toLowerCase() == fit.toLowerCase() &&
      size.size &&
      size.size.toLowerCase() == shirtSize.toLowerCase()
    ) {
      let sizeHTML = "";
      for (const key in size) {
        if (Object.hasOwnProperty.call(size, key)) {
          const element = size[key];
          sizeHTML =
            sizeHTML +
            `<li><span>${capitalizeFirstLetter(
              key
            )}</span><span class="push">${element}"</span></li>`;
        }
      }
      isSizeAvailable = true;
      $("#selected-size-details").html(sizeHTML);
    }
  }
  return isSizeAvailable;
}
function getJacketSize(fit, jacketSize, lenght_jk) {
  let isSizeAvailable = false;
  let chartData = jacketSizeChart.filter((elem) => {
    return (
      elem.fit_label.toLowerCase().trim() == fit.toLowerCase().trim() && elem.Length.toLowerCase().trim() == lenght_jk.toLowerCase().trim() &&
      parseFloat(elem["SIZE  US"]) == parseFloat(jacketSize)
    );
  });
  let sizeHTML = "";
  if (chartData.length) {
    for (const key in chartData[0]) {
      if (Object.hasOwnProperty.call(chartData[0], key)) {
        const element = chartData[0][key];
        sizeHTML =
          sizeHTML +
          `<li><span>${capitalizeFirstLetter(
            key
          )}</span><span class="push">${element}"</span></li>`;
      }
    }
    isSizeAvailable = true;
    $("#selected-size-details").html(sizeHTML);
  } else {
    sizeHTML = "";
    $("#selected-size-details").html(sizeHTML);
  }

  //    for (let index = 0; index < jacketSizeChart.length; index++) {
  //        const size = jacketSizeChart[index];
  //         let sizeHTML = ''
  //        if (size.fit_label.toLowerCase() == fit.toLowerCase() && size['SIZE  US'] && parseFloat(size['SIZE  US']) == parseFloat(jacketSize)) {

  //            for (const key in size) {
  //                if (Object.hasOwnProperty.call(size, key)) {
  //                    const element = size[key];
  //                    sizeHTML = sizeHTML + `<li><span>${capitalizeFirstLetter(key)}</span><span class="push">${element}"</span></li>`
  //                }
  //            }
  //            isSizeAvailable=true;

  //        }
  // $('#selected-size-details').html(sizeHTML)

  //    }
  return isSizeAvailable;
}

function getSizeUsingCollerAndSleeve(fit, collar, sleeve_length) {
  let isSizeAvailable = false;
  for (let index = 0; index < pantSizeChart.length; index++) {
    const size = pantSizeChart[index];
    if (
      size.fit_type.toLowerCase() == fit.toLowerCase() &&
      parseFloat(size.collar) == parseFloat(collar) &&
      parseFloat(size.sleeve_length) == parseFloat(sleeve_length)
    ) {
      let sizeHTML = "";
      for (const key in size) {
        if (Object.hasOwnProperty.call(size, key)) {
          const element = size[key];
          sizeHTML =
            sizeHTML +
            `<li><span>${capitalizeFirstLetter(
              key
            )}</span><span class="push">${element}"</span></li>`;
        }
      }
      isSizeAvailable = true;
      $("#selected-size-details").html(sizeHTML);
    }
  }
  return isSizeAvailable;
}
